import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { LabourActivitiesResponse } from '../../../../shared/interfaces/labourActivities.interface';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class LabourHandler {
  constructor(
    private http: HttpClient
  ) { }

  getActivities(): Observable<LabourActivitiesResponse> {
    const endpoint = environment.staticScripts.staticAssets + 'json/labour-activities.json';
    return this.http.get<LabourActivitiesResponse>(endpoint);
  }
}
